import { AllSelection, TextSelection } from 'prosemirror-state';
import type { EditorView } from 'prosemirror-view';

import type { OverlayPosition } from '../editor/types';

export const getToolbarPosition = (view: EditorView): OverlayPosition => {
  const selection =
    view.state.selection instanceof AllSelection
      ? TextSelection.between(view.state.selection.$from, view.state.selection.$to)
      : view.state.selection;

  const coordsFrom = view.coordsAtPos(selection.from);
  const coordsTo = view.coordsAtPos(selection.to);

  const fromNodeMaxPos = selection.$from.end(selection.$from.depth);
  const isFromNodeOverflow =
    coordsFrom.top !== view.coordsAtPos(fromNodeMaxPos).top &&
    selection.$from.parent.eq(selection.$to.parent);
  const isSelectionSameLine = coordsFrom.top === coordsTo.top;
  const fallback = {
    left: coordsFrom.left,
    top: coordsFrom.top,
  };

  // multiline (single node)
  if (!isSelectionSameLine && isFromNodeOverflow) {
    const selectionFromNode = <HTMLElement | null>(
      view.nodeDOM(selection.from - selection.$from.textOffset - 1)
    );
    if (!selectionFromNode || selectionFromNode.nodeType === Node.TEXT_NODE) return fallback;

    const selectionFromNodeRect = selectionFromNode.getBoundingClientRect();
    const diff = selectionFromNodeRect.width - (coordsFrom.left - selectionFromNodeRect.left);

    return {
      left: coordsFrom.left + diff / 2,
      top: coordsFrom.top,
    };
  }

  // multiline (multiple nodes selection)
  if (!isSelectionSameLine) {
    const endPosition = selection.$from.end();
    const endCoords = view.coordsAtPos(endPosition);
    const diff = endCoords.left - coordsFrom.left;

    return {
      left: coordsFrom.left + diff / 2,
      top: coordsFrom.top,
    };
  }

  // single line selection
  const diff = coordsTo.left - coordsFrom.left;
  return {
    left: coordsFrom.left + diff / 2,
    top: coordsFrom.top,
  };
};
